/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
CampoExtraDateDirectiva.$inject = [];
export default function CampoExtraDateDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'cargando': '=',
            'claseRow': '@'
        },
        template: require('./campos-extra-date.html'),
        controller: 'CamposExtraDateCtrl as campExtDate',
        bindToController: true
    }
}